import { Link } from 'react-router-dom';
import { FiShoppingCart, FiHeart, FiUser, FiSearch, FiMenu, FiX } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import { useCart } from '../../context/CartContext';
import { useState } from 'react';
import './Navbar.css';

export default function Navbar() {
  const { user, logout } = useAuth();
  const { cart } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.location.href = `/shop?q=${encodeURIComponent(searchQuery.trim())}`;
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <img src="/logo.svg" alt="MiniMom Co" className="navbar-logo" />
        </Link>

        <form className="navbar-search" onSubmit={handleSearch}>
          <FiSearch />
          <input
            type="text"
            placeholder="Search products..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </form>

        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <Link to="/shop" onClick={() => setMenuOpen(false)}>Shop</Link>
          <Link to="/categories" onClick={() => setMenuOpen(false)}>Categories</Link>
          {user ? (
            <>
              <Link to="/wishlist" className="navbar-icon" onClick={() => setMenuOpen(false)}>
                <FiHeart />
              </Link>
              <Link to="/cart" className="navbar-icon cart-icon" onClick={() => setMenuOpen(false)}>
                <FiShoppingCart />
                {cart.totalItems > 0 && <span className="cart-badge">{cart.totalItems}</span>}
              </Link>
              <div className="navbar-dropdown">
                <button className="navbar-icon"><FiUser /></button>
                <div className="dropdown-menu">
                  <Link to="/account" onClick={() => setMenuOpen(false)}>My Account</Link>
                  <Link to="/orders" onClick={() => setMenuOpen(false)}>Orders</Link>
                  <Link to="/support" onClick={() => setMenuOpen(false)}>Support</Link>
                  <button onClick={() => { logout(); setMenuOpen(false); }}>Logout</button>
                </div>
              </div>
            </>
          ) : (
            <Link to="/login" className="btn btn-primary btn-sm" onClick={() => setMenuOpen(false)}>Login</Link>
          )}
        </div>

        <button className="navbar-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FiX /> : <FiMenu />}
        </button>
      </div>
    </nav>
  );
}
